import React from 'react';
import classes from "./AutoRenewalModal.module.css";
import { useTranslation } from 'react-i18next';
import { FaXmark } from "react-icons/fa6";

const AutoRenewalModal = ({setModal}) => {
    const {t}=useTranslation();
    return (
        <div className={classes.container} onClick={() => setModal(false)}>
            <div className={classes.sub_container} onClick={(e) => e.stopPropagation()}>
                <button type="button" className={classes.close_btn} onClick={()=>setModal(false)}>
                    <FaXmark className={classes.close_icon} />
                </button>
                <div className={classes.msg}>
                    <p className={classes.text}>{t("102")}</p>
                </div>
            </div>
        </div>
    )
}

export default AutoRenewalModal;